import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionRoutes from '../../../components/permission/permissionRoutes';

const update = createAsyncThunk(
  'thunk/permission/delete',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionRoutes.api.generate.delete(arg?.id), {
      method: 'DELETE',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
